export default __webpack_public_path__ + "static/media/img004.9d0b5ff4.png";